module.exports = __webpack_public_path__ + "media/images/athletes/1180-ba12e6862766d01084a23cd75f1abe8e.png";